import {
  conversationMessagesResponseSchema,
  paths,
  type ConversationMessagesResponse,
} from "@go-novus/admin-api";

import {
  requestBackendResult,
  type BackendFailure,
} from "#/shared/lib/backend-api";
import type { ResultAsync } from "#/shared/lib/result";

/** 回放整段会话是另一个读操作，失败文案与列表分开挑。 */
export const getConversationMessagesOperation = "conversations.replay";

export type GetConversationMessagesOperation =
  typeof getConversationMessagesOperation;

export type GetConversationMessagesFailure =
  BackendFailure<GetConversationMessagesOperation>;

export function getConversationMessages(
  conversationId: string,
  options: { fetch?: typeof globalThis.fetch; signal?: AbortSignal } = {},
): ResultAsync<ConversationMessagesResponse, GetConversationMessagesFailure> {
  return requestBackendResult({
    fetch: options.fetch,
    method: "GET",
    operation: getConversationMessagesOperation,
    parse: (payload) => conversationMessagesResponseSchema.parse(payload),
    path: paths.inboxConversationMessages(conversationId),
    signal: options.signal,
  });
}
